import {
  getListEmpLeave,
  getListEmpDayLeave,
  getListEmpLeaveRequest,
  getSingleLeaveRequestData,
  getEmpLeaveReport,
  checkPaidLeave,
} from 'services/axios/empLeave'

// Action type
const actions = {
  FETCH_EMP_LEAVE_DATA: 'FETCH_EMP_LEAVE_DATA',
  FETCH_EMP_DAY_OFF_DATA: 'FETCH_EMP_DAY_OFF_DATA',
  FETCH_EMP_LEAVE_REQUEST_DATA: 'FETCH_EMP_LEAVE_REQUEST_DATA',
  HANDLE_PAGINATION: 'HANDLE_PAGINATION',
  HANDLE_EMP_LEAVE_REPORT: 'HANDLE_EMP_LEAVE_REPORT',
  GET_SINGLE_LEAVE_REQUEST_RECORD: 'GET_SINGLE_LEAVE_REQUEST_RECORD',
  HANDLE_PAID_LEAVE_HOUR: 'HANDLE_PAID_LEAVE_HOUR',
}

// Action creaters
export const fetchEmpLeaveData = ({ fromDashboard }) => {
  return async (dispatch) => {
    const response = await getListEmpLeave({ fromDashboard })
    dispatch({ type: actions.FETCH_EMP_LEAVE_DATA, payload: response?.data?.data })
  }
}
export const fetchEmpDayLeaveData = ({ fromDashboard }) => {
  return async (dispatch) => {
    const response = await getListEmpDayLeave({ fromDashboard })
    dispatch({ type: actions.FETCH_EMP_DAY_OFF_DATA, payload: response?.data })
  }
}
export const fetchEmpLeaveRequestData = ({
  leaveStatus,
  skip,
  limit,
  employeeValue,
  moduleId,
  leaveType,
  sortBy,
  sortOrder,
} = {}) => {
  return async (dispatch) => {
    const response = await getListEmpLeaveRequest(
      leaveStatus,
      skip,
      limit,
      employeeValue,
      moduleId,
      leaveType,
      sortBy,
      sortOrder,
    )
    dispatch({ type: actions.FETCH_EMP_LEAVE_REQUEST_DATA, payload: response?.data?.data })
  }
}
export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_PAGINATION',
    payload: pagination,
  }
}

export const getSingleLeaveRequestRecord = (id, moduleId) => {
  return async (dispatch) => {
    const response = await getSingleLeaveRequestData(id, moduleId)

    if (response?.status === 200) {
      const responseData = response?.data?.data || {}

      dispatch({
        type: actions.GET_SINGLE_LEAVE_REQUEST_RECORD,
        payload: {
          leaveRecord: responseData?.isExist || [],
          leaveBalanceSummary: responseData?.leaveBalanceSummary || null,
          finalAction: responseData?.finalAction || null,
        },
      })
    }
  }
}

export const leaveReport = ({ skip, limit, userId, month, year }) => {
  return async (dispatch) => {
    const response = await getEmpLeaveReport({ skip, limit, userId, month, year })
    if (response?.status === 200 && response?.data?.statusCode === 200) {
      dispatch({
        type: actions.HANDLE_EMP_LEAVE_REPORT,
        payload: response?.data?.data || [],
      })
    }
  }
}

export const handlePaidLeaveHour = ({ userId, year, month }) => {
  return async (dispatch) => {
    const response = await checkPaidLeave({ userId, year, month })

    if (response?.status === 200 && response?.data?.statusCode === 200) {
      dispatch({
        type: actions.HANDLE_PAID_LEAVE_HOUR,
        payload: {
          paidLeavehour: response?.data?.data,
        },
      })
    }
  }
}

export default actions
